import { ContentNotFound, Layout } from '@common'
import { ISSRPageData } from '@interfaces'
import ART_COLLECTION_NAV from '@lib/const/art-collection-nav.const'
import { CollectionsService } from '@services'
import { CollectionsAndArchiveTemplate } from '@templates'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const ArtCollectionsScreen = ({ pageData, global }: ISSRPageData) => {
  const { t } = useTranslation()
  const { asPath, pathname } = useRouter()

  if (pageData.error) {
    return (
      <Layout
        title={t('collections-and-research:collections.title')}
        navigation={global?.navigation}
        path={asPath}
      >
        <ContentNotFound />
      </Layout>
    )
  }

  return (
    <CollectionsAndArchiveTemplate
      global={global}
      pageTitle={t('collections-and-research:collections.title')}
      pathname={pathname}
      asPath={asPath}
      heroBgImageUrl={
        '/img/collections-and-research/collections/banner/collections-banner.jpg'
      }
      heroSubTitle={t('collections-and-research:collections.banner.subTitle')}
      heroTitle={t('collections-and-research:collections.banner.title')}
      heroDescription={t(
        'collections-and-research:collections.banner.description'
      )}
      artCollectionNav={ART_COLLECTION_NAV}
      activePage="collection"
      artCollectionData={pageData.data}
    />
  )
}

export default ArtCollectionsScreen

export async function getStaticProps({ locale }) {
  const pageData = {
    data: null,
    error: null,
  }

  try {
    const collections = await CollectionsService.getCollectionsByPageType(
      locale,
      'collection'
    )

    pageData.data = collections
  } catch (err) {
    if (err instanceof Error) {
      pageData.error = { message: err.message }
    }
  }

  return {
    props: { pageData },
  }
}
